<app-view-item *ngIf="readonly && selected" [text]="selected ? selected.code : ''"
  [borderless]="borderless"></app-view-item>
<app-view-item *ngIf="readonly && !selected" [text]="''" [borderless]="borderless"></app-view-item>

<div class="stock-location-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="nzAllowClear" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)" (click)="handleClick($event)"
    [nzCustomTemplate]="displayTpl" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
    [nzDropdownMatchSelectWidth]="false" [nzBorderless]="borderless" nzDropdownClassName="dropdownSelect"
    [nzMode]="mode" class="width-100" [nzOptionHeightPx]="32" [nzOptionOverflowSize]="6" [nzPlacement]="'bottomLeft'">

    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>

    <!-- Custom Add New Button at top -->
    <ng-container *aclIf="'stkloc.create'">
      <nz-option *ngIf="!searching && showAddNewButton && !this.NotShowInReport" [nzValue]="null" [nzLabel]="'__addnew__'" nzCustomContent>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
          </button>
        </div>
      </nz-option>
    </ng-container>

    <nz-option [nzValue]="'NULL'" [nzLabel]="'NON-LOCATION'" nzCustomContent *ngIf="NotShowInReport && !isLocationRestricted">
      <div class="dropdown-container">
        <strong style="color: red;">* </strong>
        <strong>NON-LOCATION</strong>
        <span>: Non-location</span>

      </div>
    </nz-option>

    <nz-option [nzValue]="'ALL'" [nzLabel]="'ALL-LOCATION'" nzCustomContent *ngIf="NotShowInReport && !isLocationRestricted">
      <div class="dropdown-container">
        <strong style="color: red;">* </strong>
        <strong>ALL-LOCATION</strong>
        <span>: All-location</span>
      </div>
    </nz-option>

    <nz-option [nzValue]="'LINE'" [nzLabel]="'line'" nzCustomContent *ngIf="NotShowInReport" nzDisabled="true">
      <div class="dropdown-container">
        -----------------------------------
      </div>
    </nz-option>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="selected ? selected.code : ''" nzCustomContent>
        <div class="dropdown-container">
          <strong>{{ o.code }}</strong>
          <span *ngIf="o.name && o.name.trim() !== ''">:</span>
          <span> {{ o.name }}</span>
        </div>
      </nz-option>
    </ng-container>
  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="stockLocationConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onStockLocationCreated($event)"
    (cancelled)="onStockLocationCancelled()" (visibleChange)="showInlineAddPanel = $event"
    (moreDetails)="onStockLocationMoreDetails()" (fieldChange)="onFieldChange($event)">
  </app-inline-add-panel>
</div>